import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import './radio-circle.css';

export default function RadioCircle(props) {
  const { size = 'medium', isChecked, isHovered, isFocused, isDisabled, isInvalid } = props;

  return (
    <div
      className={clsx('radio-circle', {
        ['radio-circle--medium']: size === 'medium',
        ['radio-circle--small']: size === 'small',
        ['radio-circle--checked']: isChecked,
        ['radio-circle--hovered']: isHovered,
        ['radio-circle--focused']: isFocused,
        ['radio-circle--disabled']: isDisabled,
        ['radio-circle--invalid']: isInvalid,
      })}
    />
  );
}

RadioCircle.displayName = 'RadioCircle';

RadioCircle.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  isChecked: PropTypes.bool,
  isHovered: PropTypes.bool,
  isFocused: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isInvalid: PropTypes.bool,
};
